// WebSocket Client for Real-time Agent Data
import { io, Socket } from 'socket.io-client';

const WEBSOCKET_URL = import.meta.env.VITE_WEBSOCKET_URL || 'http://localhost:8080';

let socket: Socket | null = null;

export function getSocket(): Socket {
    if (!socket) {
        socket = io(WEBSOCKET_URL, {
            transports: ['websocket', 'polling'],
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: Infinity,
            timeout: 10000,
        });

        socket.on('connect', () => {
            console.log('[WebSocket] Connected to agent server');
        });

        socket.on('disconnect', () => {
            console.log('[WebSocket] Disconnected from agent server');
        });

        socket.on('connect_error', (error) => {
            // Silent reconnection attempts after first error
            if (!socket?.connected) {
                console.warn('[WebSocket] Connection error:', error.message);
            }
        });
    }

    return socket;
}

export function disconnectSocket() {
    if (socket) {
        socket.disconnect();
        socket = null;
    }
}

export default { getSocket, disconnectSocket };
